import { lazy } from 'react';

// project imports
import Loadable from '../components/Loadable';
import MinimalLayout from '../layouts/MinimalLayout';
import AnimatedWelcomePage from '../views/logo-page';
import ITSupportPage from '../pages/ITSupport';
import ServerDownPage from '../pages/ServerDown';
import TimeoutErrorPage from '../pages/TimeoutError';
import ConnectionErrorPage from '../pages/ConnectionError';


// maintenance routing
const LoginPage = Loadable(lazy(() => import('../pages/loginPage/login')));
const IntroductionPage = Loadable(lazy(() => import('../pages/IntroductionPage/IntroductionPage')));
const ResettingPasswordPage = Loadable(lazy(() => import('../pages/loginPage/reset')));
const ForgotPasswordPage = Loadable(lazy(() => import('../pages/loginPage/forgot')));
const PrivacyPolicyPage = Loadable(lazy(() => import('../pages/PrivacyPolicy/PrivacyPolicy')));
// const RegisterPage = Loadable(lazy(() => import('../views/pages/authentication/Register')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      index: true,
      element: <IntroductionPage />

    },
    {
      path: '/login',
      element: <LoginPage />

    },
    {
      path: '/reset',
      element: <ResettingPasswordPage />
    },
    {
      path: '/forgot',
      element: <ForgotPasswordPage />
    },
    {
      path: '/welcome',
      element: <AnimatedWelcomePage />
    },
    {
      path: '/privacy-policy',
      element: <PrivacyPolicyPage />
    },
    {
      path: '/privacy',
      element: <PrivacyPolicyPage />
    },
    {
      path: '/it-error',
      element: <ITSupportPage />
    },
    {
      path: '/server-down',
      element: <ServerDownPage />
    },
    {
      path: '/timeout',
      element: <TimeoutErrorPage />
    },
    {
      path: '/connection-error',
      element: <ConnectionErrorPage />
    },
  ]
};

export default AuthenticationRoutes;